/* eslint-disable react/no-unknown-property */
import React, { use } from 'react'
import { Link } from 'react-router-dom'
import { TRMNotification } from '../../types/listDataTypes'
import { convertDate } from '../../global'
import Noresult from '../noresult/noresult'
import { MetadataContext } from '../../store/contexts/MetadataContextProvider'
import { postItemToNotificationList } from '../../modules/TRM/services/trmNotificationList'
import Buttons from '../buttons/buttons'

interface Props {
  tabId?: any,
  notificationItems: TRMNotification[]
  getNotications: () => Promise<void>
  setNotificationData: React.Dispatch<React.SetStateAction<TRMNotification[]>>
}

export default function Notificationtabcontent(props: Props) {
  const {statusMetadata} = use(MetadataContext)
  let notificationItems: any = props?.notificationItems
  const onNotificationClicked = async (notification: TRMNotification) => {
    // Remove from UI immediately (optimistic update)
    props.setNotificationData(prev => prev.filter(item => item.NotificationGUID !== notification.NotificationGUID))
    const newItem = {
      ...notification,
      IsRead: true
    }
    // Update backend asynchronously without waiting
    try {
      await postItemToNotificationList(newItem)
    } catch (error) {
      console.error('Error updating notification:', error)
      // Refresh notifications if backend update fails
      props?.getNotications()
    }
  }
  const listItems = notificationItems.map((items: TRMNotification) =>
    <li tabIndex={0} aria-describedby={items.NotificationGUID} id={items.NotificationGUID} 
    // className={items.listclassname} 
    notification-code={items?.NotificationType === 'ACTION' ? 1: 2 } key={items.NotificationGUID}>
      <div className='d-flex'>
        <div className='d-flex flex-column col'>
          <div className='font-13 mb-1'>
            <Link
              to={statusMetadata?.length && items?.StatusCode < statusMetadata![5].StatusCode ? `/inquiries-detailview/${items?.InquiryGUID}` : `/workorders-detailview/${items?.InquiryGUID}`}
              title={items?.Subject}
              className={`sora-medium font-13 ${!items?.IsRead ? 'text-color-11' : 'text-color-7'}`}
              onClick={() => onNotificationClicked(items)}
            >
              {items?.Subject}
            </Link>
          </div>
          <div className="textcolor-37 font-12">
            {convertDate(items?.ItemCreated, 'date')}
          </div>
        </div>
        <div className=''>
          <Buttons
            label="Close"
            className='p-0 btn btn-xs font-0 m-0 lh-normal'
            icon="icon-rb-close font-9 p-1"
            type="button"
            onClick={() => onNotificationClicked(items)}
          />
        </div>
        <div>

        </div>
      </div>
    </li>
  )
  return (
    <>
      <ul className='notification-list-items'>
        {listItems?.length > 0 ? listItems : <div className='d-flex align-items-center justify-content-center min-h-150'><Noresult/></div>}
      </ul>
    </>
  )
}
